import { useEffect, useState } from "react"
import { useGetFiltrosMarcasLazyQuery } from "src/gql/schema"
import { FlexibleTableHeaderColumn } from "src/shared/components/data-display/FlexibleTable/flexible-table-items.interface"
import { HeaderProps } from "./useHeaderProps"

const useMarcasHeader = <T extends string>({ headerValue, valueToDisplay }: HeaderProps<T>): FlexibleTableHeaderColumn => {
    const [fetchFiltros] = useGetFiltrosMarcasLazyQuery()
    const [items, setItems] = useState<string[]>([])
    const [startingItems, setStartingItems] = useState<string[]>([])
    const [loading, setLoading] = useState(false)

    const resetList = () => {
        setItems(startingItems)
    }

    useEffect(() => {
        setLoading(true)
        fetchFiltros()
            .then((res) => {
                const data = res.data?.filtros_reportes?.marca || []
                setItems(data)
                setStartingItems(data)
            })
            .finally(() => setLoading(false))
    }, [])

    return {
        value: headerValue,
        valueToDisplay,
        onInputFilterSuggestionChange: (v) => {
            if (loading) return
            if (!v.value) {
                resetList()
                return
            }
            if (v.headerValue === headerValue) {
                setLoading(true)
                fetchFiltros({ variables: { filter_text: v.value } })
                    .then((res) => {
                        setItems(res.data?.filtros_reportes?.marca || [])
                    })
                    .finally(() => setLoading(false))
            }
        },
        filterMenu: items
            .map((v) => ({ value: v, valueToDisplay: v }))
            .filter((item) => item.value !== ""),
        debounceSearchMSTime: 500,
        filterSuggetions: true,
    }
}

export default useMarcasHeader
